import script from "./EffectsCarouselPreloader.vue?vue&type=script&setup=true&lang=ts"
export * from "./EffectsCarouselPreloader.vue?vue&type=script&setup=true&lang=ts"

import "./EffectsCarouselPreloader.vue?vue&type=style&index=0&id=7a4cfc0c&lang=scss"

const __exports__ = script;

export default __exports__